import { render, staticRenderFns } from "./Plugintable.vue?vue&type=template&id=e65000b6&scoped=true"
import script from "./Plugintable.vue?vue&type=script&lang=js"
export * from "./Plugintable.vue?vue&type=script&lang=js"
import style0 from "./Plugintable.vue?vue&type=style&index=0&id=e65000b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65000b6",
  null
  
)

export default component.exports